exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".avatar-popup-menu .avatar-popup-action{background:#fff;padding:0 10px 10px}.avatar-popup-menu .avatar-popup-action .btn{margin:0;width:100%}", "", {"version":3,"sources":["/home/circleci/repo/src/components/ui/AvatarPopup.vue"],"names":[],"mappings":"AACA,wCACE,gBAAiB,AACjB,mBAA0B,CAC3B,AACD,6CACE,SAAU,AACV,UAAY,CACb","file":"AvatarPopup.vue","sourcesContent":["\n.avatar-popup-menu .avatar-popup-action {\n  background: #fff;\n  padding: 0 10px 10px 10px;\n}\n.avatar-popup-menu .avatar-popup-action .btn {\n  margin: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16335317","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/AvatarPopup.vue
// module id = 1153
// module chunks = 16 17